import type { FC, PropsWithChildren, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from 'contexts/AuthContext';
import { RoutePathsE } from 'declarations/enums/routes';
import useLocationStore from 'hooks/store/useLocationStore';

const PublicRoutes: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const { isUserLoggedIn } = useAuth();
  const location = useLocationStore(state => state.location);

  if (isUserLoggedIn) {
    const path = location.pathName
      ? `${location.pathName}${location.search}`
      : RoutePathsE.TICKETS_PAGE;

    return <Navigate to={path} />;
  }

  return <>{children}</>;
};

export default PublicRoutes;
